import { Tooltip } from 'floating-vue';

export default {
  props: {
    content: {
      type: String,
    },
    className: {
      type: String,
    },
  },

  components: {
    Tooltip,
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    placement() {
      return this.windowWidth >= 768 ? 'right' : 'bottom';
    },
  },

  methods: {
    stopAll(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  watch: {},
};
